import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import faArrowRightFromBracket from "../../fontawesome/pro-regular-svg-icons/faArrowRightFromBracket";

type Props = {
    caption: string;
    disabled?: boolean;
    className?: string;
    onClick?: (event: React.FormEvent) => void;
};

const LogoutButton: React.FC<Props> = ({
    caption = "Сменить аккаунт",
    disabled,
    className = "btn btn-outline-primary w-100 d-flex gap-2 align-items-center justify-content-center",
    onClick,
}) => {
    return (
        <button disabled={disabled} className={className} onClick={onClick}>
            <FontAwesomeIcon icon={faArrowRightFromBracket} />
            <span className="ms-2">{caption}</span>
        </button>
    );
};

export default LogoutButton;
